import "./Home.module.css";
import EnTTe from "@/reusable_sections/Header";
import ExpertiseEnDBouchage from "./sections/ExpertiseEnDBouchage";
import NosServicesSpCialisS from "./sections/NosServicesSpCialisS";
import PourquoiChoisirOtSolution from "./sections/PourquoiChoisirOtSolution";
import ZonesDeServiceRapide from "./sections/ZonesDeServiceRapide";
import TMoignagesClients from "./sections/TMoignagesClients";
import QuestionsFrQuentes from "./sections/QuestionsFrQuentes";
import PiedDePage from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <EnTTe />
      <ExpertiseEnDBouchage />
      <NosServicesSpCialisS />
      <PourquoiChoisirOtSolution />
      <ZonesDeServiceRapide />
      <TMoignagesClients />
      <QuestionsFrQuentes />
      <PiedDePage />
    </div>;
}